import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import { oidcConfig } from "./auth/authConfig";
import { getEnv } from "./hooks/useEnv";
import "./analytics/posthog";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ChakraProvider>
      <AuthProvider {...oidcConfig(getEnv())}>
        <App />
      </AuthProvider>
    </ChakraProvider>
  </React.StrictMode>,
);
